import { ShimmerLoader } from '@brandfolder/react';
import React, { FunctionComponent, useRef, useEffect, useCallback } from 'react';

import './styles/section_placeholder.scss';

interface SectionPlaceholderProps {
  isPreview?: boolean;
  onEnterViewport: () => void;
  sectionName: string;
}

const SectionPlaceholder: FunctionComponent<SectionPlaceholderProps> = ({
  isPreview = false,
  onEnterViewport,
  sectionName,
}) => {
  const sentinelRef = useRef<HTMLElement>(null);
  const hasFiredRef = useRef(false);

  const stableCallback = useCallback(() => {
    if (hasFiredRef.current) return;
    hasFiredRef.current = true;
    onEnterViewport();
  }, [onEnterViewport]);

  useEffect(() => {
    const node = sentinelRef.current;
    if (!node) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          stableCallback();
          observer.disconnect();
        }
      },
      { threshold: 0 }
    );

    observer.observe(node);

    return (): void => {
      observer.disconnect();
    };
  }, [stableCallback]);

  return (
    <article
      ref={sentinelRef}
      className={'section-container card-view section-placeholder'}
    >
      <div
        className={`section-header no-print ${isPreview ? 'section-header__remove-sticky' : ''}`}
      >
        <div className="section-title-count">
          <div className="section-title-checkbox-container">
            <h2 className="section-title" tabIndex={-1}>{sectionName}</h2>
          </div>
          <span className="asset-count section-placeholder__count-shimmer">
            <ShimmerLoader numLines={1} />
          </span>
        </div>
      </div>
      <ul className="card-list section-placeholder__card-list">
        <li className="section-placeholder__shimmer" />
        <li className="section-placeholder__shimmer" />
      </ul>
    </article>
  );
};

export default SectionPlaceholder;
